// src/pages/BikeHighlights.js
import React, { useMemo, useState } from "react";

/**
 * BikeHighlights — interactive timeline of bike-world highlights.
 * - Click / arrow-key through dots to open details
 * - No extra libraries
 *
 * Edit the DATA array to add/remove highlights.
 * Tip: If you want local/community items, add "location" like "Oakland / East Bay".
 */

const DATA = [
  {
    id: "safety-streets",
    name: "Protected lanes go in on a major corridor",
    year: "2026",
    date: "2026-02-15",
    location: "East Bay",
    blurb:
      "biiiiig safety upgrade: new protected bike lanes sections. but the cars love to drive in the bright green protected bike lanes anyways.",
    impact:
      "Safer commutes, more new riders, calmer crossings. Worth celebrating ",
    cause: "City capital project",
    image: null,
    credit: null,
    links: [
      { label: "How to support it", href: "https://bikeeastbay.org/" }
    ]
  },
  {
    id: "community-ride",
    name: "Community ride season kicks off",
    year: "2026",
    date: "2026-03-02",
    location: "Berkeley, Oakland",
    blurb:
      "Group rides are the best! you learn new streets, and the city feels like it belongs to you and your hoard of bikers for a few hours",
    impact:
      "Low-barrier entry point for new cyclists",
    cause: "Berkeley Bike Club",
    image: null,
    credit: null,
    links: [
      { label: "Find local rides", href: "https://www.strava.com/clubs" }
    ]
  },
  {
    id: "racing-weekend",
    name: "A spring classics weekend reminds everyone why bikes are life",
    year: "2026",
    date: "2026-04-06",
    location: "Global",
    blurb: 
      "Even if you don’t race, it’s the most fun kind of sports narrative.",
    impact: "More people watching cycling = more people trying cycling.",
    cause: "The calendar",
    image: null,
    credit: null,
    links: [
      { label: "Race calendar", href: "https://www.uci.org/" }
    ]
  },
  {
    id: "gear-drop",
    name: "The gear drop everyone’s actually excited about",
    year: "2026",
    date: "2026-05-10",
    location: "Bike shops",
    blurb:
      "better fit options, smarter storage, and stuff that looks good without trying too hard.",
    impact: "More comfort = more miles = more joy!",
    cause: "Brands finally listening (a little)",
    image: null,
    credit: null,
    links: [
      { label: "My notes", href: "/#/Highlights" }
    ]
  },
  {
    id: "dirt-season",
    name: "Dirt season: the first perfect day on singletrack",
    year: "2026",
    date: "2026-06-01",
    location: "Bay Area hills",
    blurb:
      "your tires feel psychic and the sun dapples the trail for a beautiful 11 hours of the day",
    impact: "Morale boost for the whole summer.",
    cause: "good tires",
    image: null,
    credit: null,
    links: [
      { label: "Trail conditions", href: "https://www.mtbproject.com/" }
    ]
  }
];

export default function BikeHighlights() {
  const [activeId, setActiveId] = useState(DATA[DATA.length - 1].id);

  // Sort by date ascending for a left-to-right timeline
  const items = useMemo(
    () => [...DATA].sort((a, b) => new Date(a.date) - new Date(b.date)),
    []
  );

  const active = items.find((d) => d.id === activeId) ?? items[0];

  return (
    <div style={{ minHeight: "100vh", background: "transparent" }}>
      <header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backdropFilter: "blur(10px)",
          background: "rgba(255,255,255,0.65)",
          borderBottom: "1px solid rgba(15,23,42,0.08)"
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "14px 18px" }}>
          <h1
            style={{
              margin: 0,
              color: "#0f172a",
              fontSize: 26,
              fontFamily: "Times New Roman"
            }}
          >
            Bike World Highlights
          </h1>
          <p style={{ margin: "6px 0 0", color: "#334155" }}>
            Community news, racing moments, gear drops, and little reasons to ride.
          </p>
        </div>
      </header>

      <main style={{ maxWidth: 1100, margin: "0 auto", padding: "18px" }}>
        {/* Timeline rail */}
        <div
          role="tablist"
          aria-label="Bike highlights timeline"
          style={{
            overflowX: "auto",
            padding: "10px 6px 16px",
            borderBottom: "1px dashed rgba(15,23,42,0.20)",
            marginBottom: 16,
            scrollbarWidth: "thin"
          }}
        >
          <div
            style={{
              display: "grid",
              gridAutoFlow: "column",
              gap: 22,
              alignItems: "center",
              position: "relative"
            }}
          >
            {items.map((d) => {
              const selected = d.id === activeId;
              return (
                <button
                  key={d.id}
                  role="tab"
                  aria-selected={selected}
                  onClick={() => setActiveId(d.id)}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowRight") {
                      const i = items.findIndex((x) => x.id === d.id);
                      setActiveId(items[Math.min(i + 1, items.length - 1)].id);
                    } else if (e.key === "ArrowLeft") {
                      const i = items.findIndex((x) => x.id === d.id);
                      setActiveId(items[Math.max(i - 1, 0)].id);
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    outlineOffset: 4
                  }}
                  title={`${d.year} — ${d.name}`}
                >
                  <div style={{ display: "grid", justifyItems: "center", gap: 6 }}>
                    <span
                      style={{
                        width: selected ? 18 : 14,
                        height: selected ? 18 : 14,
                        borderRadius: "999px",
                        background: selected ? "#6366f1" : "#94a3b8",
                        border: "2px solid rgba(15,23,42,0.85)",
                        boxShadow: selected
                          ? "0 0 0 6px rgba(99,102,241,0.22)"
                          : "0 0 0 2px rgba(15,23,42,0.08)"
                      }}
                    />
                    <span
  style={{
    color: selected ? "#6366f1" : "#94a3b8",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: "0.5px"
  }}
>
  {fmtMonth(d.date)}
</span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Details panel with optional right-side image */}
        <article
          aria-live="polite"
          style={{
            border: "1px solid rgba(99,102,241,0.35)",
            background: "rgba(192, 192, 243, 0.85)",
            borderRadius: 16,
            padding: 20,
            color: "#f1f5f9",
            boxShadow: "0 20px 40px rgba(0,0,0,0.4)"
          }}
>
          <div
            className="highlight-detail"
            style={{
              display: "grid",
              gridTemplateColumns: active.image ? "1fr minmax(240px, 360px)" : "1fr",
              gap: 16,
              alignItems: "start"
            }}
          >
            {/* LEFT: text */}
            <div>
              <header style={{ marginBottom: 8 }}>
                <h2 style={{ margin: "0 0 4px", fontSize: 22, color: "#0f172a" }}>
                  {active.name}
                </h2>
                <p style={{ margin: 0, color: "#334155" }}>
                  {fmtDate(active.date)} · {active.location}
                </p>
              </header>

              <p style={{ marginTop: 10, color: "#0f172a" }}>{active.blurb}</p>

              <dl
                style={{
                  display: "grid",
                  gridTemplateColumns: "140px 1fr",
                  gap: "6px 12px",
                  marginTop: 12
                }}
              >
                {active.impact && (
                  <>
                    <dt style={dtStyle}>Why it matters</dt>
                    <dd style={ddStyle}>{active.impact}</dd>
                  </>
                )}

                {active.cause && (
                  <>
                    <dt style={dtStyle}>How it happened</dt>
                    <dd style={ddStyle}>{active.cause}</dd>
                  </>
                )}
              </dl>

              {active.links?.length > 0 && (
                <div style={{ marginTop: 12, display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {active.links.map((l) => (
                    <a
                      key={l.href}
                      href={l.href}
                      target={l.href.startsWith("/#/") ? undefined : "_blank"}
                      rel={l.href.startsWith("/#/") ? undefined : "noopener noreferrer"}
                      style={{
                        textDecoration: "none",
                        color: "#0f172a",
                        background: "rgba(99,102,241,0.14)",
                        border: "1px solid rgba(99,102,241,0.35)",
                        borderRadius: 999,
                        padding: "6px 10px",
                        fontSize: 13,
                        fontWeight: 700
                      }}
                    >
                      {l.label} ↗
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* RIGHT: image */}
            {active.image && (
              <figure style={{ margin: 0 }}>
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "4 / 3",
                    overflow: "hidden",
                    borderRadius: 12,
                    border: "1px solid rgba(15,23,42,0.12)",
                    boxShadow: "0 10px 26px rgba(15,23,42,0.18)",
                    background: "rgba(255,255,255,0.4)"
                  }}
                >
                  <img
                    src={active.image}
                    alt={active.name}
                    loading="lazy"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block"
                    }}
                  />
                </div>
                {active.credit && (
                  <figcaption style={{ fontSize: 12, color: "#475569", marginTop: 6 }}>
                    {active.credit}
                  </figcaption>
                )}
              </figure>
            )}
          </div>

          {/* mobile stacking rule */}
          <style>{`
            @media (max-width: 720px) {
              .highlight-detail { grid-template-columns: 1fr !important; }
            }
          `}</style>
        </article>
      </main>
    </div>
  );
}

const dtStyle = { color: "#4338ca", fontWeight: 800, fontSize: 13 };
const ddStyle = { margin: 0, fontSize: 14, color: "#0f172a" };

function fmtMonth(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      month: "short"
    });
  } catch {
    return "";
  }
}

function fmtDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return iso;
  }
}